import React, { PureComponent } from 'react';
import injectSheet from 'react-jss';
// import Router from 'next/router';
import { Layout, Menu, Icon } from 'antd';
import { FormattedRelative, FormattedMessage, defineMessages } from 'react-intl';

import { Router, Link } from 'src/routes';
import AuthStorage from 'src/utils/AuthStorage';

import styles from './styles';

const { Sider } = Layout;
const SubMenu = Menu.SubMenu;

@injectSheet(styles)
class SiderLayout extends PureComponent {
  state = {
    collapsed: false,
    current: 'dashboard',
    openKeys: ''
  };

  componentDidMount() {
    const current = Router.pathname.replace('/', '');
    this.setState({ current });
    this.defindRouter(current);
  }

  onCollapse = collapsed => {
    this.setState({ collapsed });
  };

  handleClick = e => {
    if (e !== this.state.openKeys) {
      this.setState({
        current: e.key,
        openKeys: e.keyPath[1]
      });
    }
    {
      this.setState({
        current: e.key,
        openKeys: ''
      });
    }
  };

  defindRouter = current => {
    switch (current) {
      case 'companies': {
        this.setState({
          current: 'companies'
        });
        break;
      }
      case 'create-company': {
        this.setState({
          current: 'companies'
        });
        break;
      }
      case 'company-detail': {
        this.setState({
          current: 'companies'
        });
        break;
      }
      case 'employees': {
        this.setState({
          current: 'employees'
        });
        break;
      }
      case 'employee-details': {
        this.setState({
          current: 'employees'
        });
        break;
      }
      case 'create-employee': {
        this.setState({
          current: 'employees'
        });
        break;
      }
      case 'restaurants': {
        this.setState({
          current: 'restaurants'
        });
        break;
      }
      case 'restaurants-detail': {
        this.setState({
          current: 'restaurants'
        });
        break;
      }
      case 'restaurants-create': {
        this.setState({
          current: 'restaurants'
        });
        break;
      }
      case 'settings': {
        this.setState({
          current: 'settings'
        });
        break;
      }
      case 'credits-affection-employee': {
        this.setState({
          current: 'credits'
        });
        break;
      }
      case 'credits-companies-employees': {
        this.setState({
          openKeys: 'credits-history',
          current: 'credits-history-companies-employees'
        });
        break;
      }
      case 'bo-history': {
        this.setState({
          openKeys: 'bo-history',
          current: 'bo-history'
        });
        break;
      }
      case 'bo-payment-tracking': {
        this.setState({
          openKeys: 'bo-payment-tracking',
          current: 'bo-payment-tracking'
        });
        break;
      }
      case 'credits-companies': {
        this.setState({
          openKeys: 'credits-history',
          current: 'credits-history-companies'
        });
        break;
      }
      case 'credits-employees': {
        this.setState({
          openKeys: 'credits-history',
          current: 'credits-history-employees'
        });
        break;
      }
      case 'credits-restaurants': {
        this.setState({
          openKeys: 'credits-history',
          current: 'credits-history-restaurants'
        });
        break;
      }
      case 'users': {
        this.setState({
          openKeys: 'settings'
        });
        break;
      }
      case 'settings-metadata': {
        this.setState({
          openKeys: 'settings'
        });
        break;
      }
      case 'islands': {
        this.setState({
          openKeys: 'settings'
        });
        break;
      }
      case 'island': {
        this.setState({
          current: 'settings',
          // current: 'islands'
        });
        break;
      }
      case 'users-detail': {
        this.setState({
          current: 'settings',
          // current: 'islands'
        });
        break;
      }
      case 'restaurants-groups': {
        this.setState({
          current: 'restaurants-groups',
        });
        break;
      }
      case 'restaurants-groups-create': {
        this.setState({
          current: 'restaurants-groups'
        });
        break;
      }
      case 'restaurants-groups-detail': {
        this.setState({
          current: 'restaurants-groups',
        });
        break;
      }
      default: {
        this.setState({
          openKeys: ''
        });
      }
    }
  };

  setSubMenu = e => {
    this.setState({ openKeys: e.key });
  };

  render() {
    const { classes } = this.props;
    const { current, openKeys, defaultSelectedKeys } = this.state;
    const { isTama, isAdmin, isCompany, isRestaurant, isEmployee, idInfo, isGroupRestaurant } = AuthStorage;

    return (
      // <Sider collapsible collapsed={this.state.collapsed} onCollapse={this.onCollapse}>
      <Sider className={classes.sider}>
        <div className={classes.logo}>
          <Link route="/">
            <img src="/static/assets/images/logo/logo.png" />
          </Link>
        </div>
        <Menu
          theme="dark"
          onClick={this.handleClick}
          defaultSelectedKeys={[`${current}`]}
          mode="inline"
          openKeys={[`${openKeys}`]}
          defaultOpenKeys={[`${openKeys}`]}
          selectedKeys={[this.state.current]}>
          {isTama || isAdmin || isCompany || isRestaurant || isGroupRestaurant ? (
            <Menu.Item key="dashboard" onClick={() => Router.pushRoute('/')}>
              <Icon type="pie-chart" />
              <Link route="/">
                <FormattedMessage id="nav.dashboard" defaultMessage="Dashboard" />
              </Link>
            </Menu.Item>
          ) : (
            ''
          )}

          {/* {isRestaurant ? (
            <Menu.Item key="refunds" onClick={() => Router.pushRoute('/refunds')}>
              <Icon type="gold" />
              <Link route="/">
                <FormattedMessage id="nav.refund" defaultMessage="Refunds" />
              </Link>
            </Menu.Item>
          ) : (
            ''
          )} */}

          {isAdmin && (
            <Menu.Item key="companies" onClick={() => Router.pushRoute('/companies')}>
              <Icon type="home" />
              <FormattedMessage id="nav.companise" defaultMessage="Companies" />
            </Menu.Item>
          )}

          {isCompany && (
            <Menu.Item onClick={() => Router.pushRoute(`/company-detail/${idInfo}`)}>
              <Icon type="home" />
              Ma société
            </Menu.Item>
          )}

          {isRestaurant && (
            <Menu.Item onClick={() => Router.pushRoute(`/restaurants-detail/${idInfo}`)}>
              <Icon type="shop" />
              Mon établissement
            </Menu.Item>
          )}

          {isAdmin || isCompany ? (
            <Menu.Item key="employees" onClick={() => Router.pushRoute('/employees')}>
              <Icon type="team" />
              <FormattedMessage id="nav.employees" defaultMessage="Employees" />
            </Menu.Item>
          ) : (
            ''
          )}

          {isAdmin ? (
            <Menu.Item
              key="restaurants-groups"
              onClick={() => Router.pushRoute('/restaurants-groups')}>
              <Icon type="gold" />Groupes d'établissements
            </Menu.Item>
          ) : (
            ''
          )}

          {isAdmin ? (
            <Menu.Item
              key="restaurants"
              onClick={() => Router.pushRoute('/restaurants')}>
              <Icon type="shop" />
              <FormattedMessage id="nav.restaurants" defaultMessage="Restaurants" />
            </Menu.Item>
          ) : (
            ''
          )}

          {isTama ? (
            <Menu.Item key="credits" onClick={() => Router.pushRoute('/credits')}>
              <Icon type="credit-card" />
              <FormattedMessage
                id="nav.credits.history"
                defaultMessage="Credits history" />
            </Menu.Item>
          ) : (
            ''
          )}

          {isTama || isCompany ? (
            <Menu.Item key="credit-history" onClick={() => Router.pushRoute('/credit-history')}>
              <Icon type="history" />
              <FormattedMessage id="nav.credits" defaultMessage="Credits" />
            </Menu.Item>
            // <SubMenu
            //     key="credits-history"
            //     onTitleClick={this.setSubMenu}
            //     title={
            //         <span>
            //             <Icon type="history" />
            //             <FormattedMessage
            //                 id="nav.credits.history"
            //                 defaultMessage="Credits history"/>
            //         </span>
            //     }>
            //     {(isTama || isCompany) && (
            //         <Menu.Item
            //             key="credits-history-companies-employees"
            //             onClick={() => Router.pushRoute('/credits-companies-employees')}>
            //             <FormattedMessage
            //                 id="nav.companise"
            //                 defaultMessage="Companies"/>
            //             <small style={{ margin: "0 5px"}}>></small>
            //             <FormattedMessage
            //                 id="nav.employees"
            //                 defaultMessage="Employees"/>
            //         </Menu.Item>
            //     )}
            //     {(isTama || isCompany) && (
            //     <Menu.Item
            //         key="credits-history-companies"
            //         onClick={() => Router.pushRoute('/credits-companies')}>
            //         <FormattedMessage
            //             id="nav.tamaa"
            //             defaultMessage="Tama'a"/>
            //         <small style={{ margin: "0 5px"}}>></small>
            //         <FormattedMessage
            //             id="nav.companise"
            //             defaultMessage="Companies"/>
            //     </Menu.Item>
            //     )}
            //     {(isTama || isCompany) && (
            //     <Menu.Item
            //         key="credits-history-employees"
            //         onClick={() => Router.pushRoute('/credits-employees')}>
            //         <FormattedMessage
            //             id="nav.tamaa"
            //             defaultMessage="Tama'a"/>
            //         <small style={{ margin: "0 5px"}}>></small>
            //         <FormattedMessage
            //             id="nav.employees"
            //             defaultMessage="Employees"/>
            //     </Menu.Item>
            //     )}
            //     {isTama && (
            //     <Menu.Item
            //         key="credits-history-restaurants"
            //         onClick={() => Router.pushRoute('/credits-restaurants')}>
            //         <FormattedMessage
            //             id="nav.tamaa"
            //             defaultMessage="Tama'a"/>
            //         <small style={{ margin: "0 5px"}}>></small>
            //         <FormattedMessage
            //             id="nav.restaurants"
            //             defaultMessage="Restaurants"/>
            //     </Menu.Item>
            //     )}
            // </SubMenu>
          ) : (
            ''
          )}

          {/* {isRestaurant && (
            <Menu.Item
            key="credits-refund"
            onClick={() => Router.pushRoute('/credits-restaurants')}>
            <Icon type="credit-card"/>
            <FormattedMessage
            id="nav.credits.refund"
            defaultMessage="Refund"/>
            </Menu.Item>
            )} */}

          {isTama ? (
            <Menu.Item key="bo-payment-tracking"
              onClick={() => Router.pushRoute('/payment-tracking')}>
              <Icon type="container" />
              <FormattedMessage id="nav.bo.follow.payment" defaultMessage="Suivi des paiements" />
            </Menu.Item>
          ) : (
            ''
          )}

          {isAdmin ? (
            <Menu.Item key="bo-history"
              onClick={() => Router.pushRoute('/bo-history')}>
              <Icon type="calendar" />
              <FormattedMessage id="nav.bo.history" defaultMessage="Journaux d'évènements" />
            </Menu.Item>
          ) : (
            ''
          )}

          {isTama ? (
            <Menu.Item key="credits-expiry"
              onClick={() => Router.pushRoute('/credits-expiry')}>
              <Icon type="unlock" />
              <FormattedMessage id="nav.bo.creditsexpiry" defaultMessage="Suivi crédits expirés" />
            </Menu.Item>
          ) : (
            ''
          )}

          {/* {isTama || isRestaurant ? ( */}
          {isAdmin ? (
            <Menu.Item key="transactions"
              onClick={() => Router.pushRoute('/transactions')}>
              <Icon type="form" />
              <FormattedMessage id="nav.transactions" defaultMessage="Transactions" />
            </Menu.Item>
          ) : (
            ''
          )}

          {isAdmin ? (
            <Menu.Item key="settings"
              onClick={() => Router.pushRoute('/settings')}>
              <Icon type="setting" />
              <FormattedMessage id="nav.setting" defaultMessage="Settings" />
            </Menu.Item>
          ) : (
            ''
          )}

          {
            isGroupRestaurant ? (
              <Menu.Item key="groupRestaurant"
                onClick={() => Router.pushRoute(`/restaurants-groups-detail/${idInfo}`)}>
                <Icon type="gold" />
                <span>Mon groupe d'établissements</span>
              </Menu.Item>
            ) : (
              ''
            )}

        </Menu>
      </Sider>
    );
  }
}

export default SiderLayout;
